// Remove any non-numeric characters for the actual call
export const getCleanPhoneNumber = (phone: string) =>
  phone
    .replace(/[^\d+,#]/g, "")
    .replace(/(?!^\+)(?!.*,)(?!.*#)./g, (char) => char.replace(/\D/g, ""));

export const handlePhoneCall = (phoneNumber: string) => {
  const cleanPhoneNumber = getCleanPhoneNumber(phoneNumber);
  window.location.href = `tel:${cleanPhoneNumber}`;
};

export const phoneWithSupportIdIfEnabled = (
  hideSupportId?: boolean,
  phone?: string,
  supportId?: string
) => (hideSupportId ? `${phone},,${supportId}#` : phone);
